import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import moment from "moment";
import Members from "./Members";
import { useNavigate } from "react-router-dom";
import Leaderboard from "./Leaderboard";
import dummyTournamentImg from "../../../assets/customerAssets/football.png";
import shareSVG from "../../../assets/customerAssets/icons/share.svg";
import { toast } from "react-toastify";
import VideosComponent from "./VideosComponent";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90dvw",
  height: "90dvh",
  bgcolor: "#242743",
  border: "1px solid #414466",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  outline: "none",

  //   p: 4,
};

const headStype = {
  padding: "15px 15px",
  borderBottom: "1px solid #414466",
  display: "flex",
  alignItems: "center",
};

const contentStyle = {
  padding: "15px 15px",
  flexGrow: "1",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
};

const Index = ({ tournament, setTournament }) => {
  const navigate = useNavigate();
  return (
    <Box className="view_feature_wrapper">
      <Box className="header club_header">
        <IconButton
          onClick={() => {
            navigate("/myaccount/2");
          }}
        >
          <ArrowBackIcon sx={{ color: "white" }} />
        </IconButton>

        <Box className="text_div club_text_div">
          <Typography component={"span"} className="title club_title">
            {tournament?.title}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ borderBottom: "1px solid #414466" }}></Box>
      <Box className="content club_content">
        <Box className={"content_a club_content_a"}>
          <Box className="img_wrapper club_img_wrapper">
            <img src={tournament?.img || dummyTournamentImg} />
          </Box>

          <Box className={"share-div"}>
            <Button
              onClick={async () => {
                if (tournament.shareLink) {
                  await navigator.clipboard.writeText(tournament.shareLink);
                  toast.success("Share link copied!");
                } else {
                  toast.error("No share link found!");
                }
              }}
            >
              <img src={shareSVG} height={20} width={20} alt="share"></img>{" "}
              Share
            </Button>
          </Box>
        </Box>

        <Box className="content_b club_content_b">
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Description: </strong>
            {tournament?.description}
          </Typography>
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            {/* <strong>Video From (UK/International): </strong> */}
            <strong>Tournament: </strong>
            {tournament.club}
            {/* {goal?.from_uk ? "England" : "International"} */}
          </Typography>
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Video From (UK/International): </strong>
            {tournament.from_uk ? "England" : "International"}
          </Typography>
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Created By: </strong>
            {tournament?.Owner?.firstName + " " + tournament?.Owner?.lastName}
          </Typography>
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Created On: </strong>
            {moment(tournament?.createdAt).format("MM/DD/YYYY")}
          </Typography>
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>City/Town: </strong>
            {tournament?.region}
          </Typography>

          <Box className="content_b_a club_content_b_a">
            <Button className="category_button club_category_button">
              {tournament?.tournamentCategory?.name}
            </Button>
            <Button className="category_button club_category_button">
              {tournament?.visibility ? "Public" : "Private"}
            </Button>
          </Box>
        </Box>

        <Members members={tournament.invitedUsers} />

        <Box className={"videos_preview_wrapper"}>
          <Typography component={"h2"}>Videos</Typography>
          <VideosComponent videos={tournament.tournamentGoalVideos} />
        </Box>

        <Leaderboard
          setTournamentData={setTournament}
          goals={tournament.tournamentGoalVideos}
        />
      </Box>
    </Box>
  );
};

export default Index;
